import { ArrowLeftOutlined } from '@ant-design/icons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SettingsRoutes } from '../../../../../routes/settings-routes';
import { BillingPlans } from '../BillingPlans/BillingPlans';
import priceTagIcon from './price-tag-icon.png';
import styles from './ManageSubsctiptionPanel.module.css';
import classNames from 'classnames';
import { BookDemoButton } from '../../../../../common/buttons/BookDemoButton/BookDemoButton';
import { BILLING_PAGE_UTM } from '../../../XRayOnboarding/WebsiteReportSummary/constants';
import { useCompanyCRUDActions } from '@mm/state/actions/CompanyCRUDActions';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import { useSelector } from 'react-redux';
import { getBasePath } from '../SubscriptionTabsArea/ActiveSubscriptionTab/helpers';

export type ManageSubsctiptionProps = {
  accountName?: string;
  downgradePlansIds?: number[];
};

export const BillingModalFooter = ({ className }: { className?: string }) => {
  const companyId = useSelector(selectActiveCompanyId);
  const { update } = useCompanyCRUDActions();
  const location = useLocation();
  const history = useHistory();
  const { closeModal } = useModalActions();
  const isManageSubscriptionsPage = location.pathname.includes(
    getBasePath(SettingsRoutes.billing.manageSubscrptions.path),
  );

  const handleBack = () => {
    history.push(SettingsRoutes.billing.getLink());
  };
  const onRequestEnteriprisePlanScheduled = async () => {
    await update({
      id: companyId,
      bookAnEnterprise: true,
    });
    if (isManageSubscriptionsPage) {
      handleBack();
    } else {
      closeModal();
    }
  };

  return (
    <div className={classNames(styles.footer, className)}>
      <img src={priceTagIcon} className={styles.priceTagIcon} />
      <div className={styles.footerText}>
        Contact Sales for an extended free trial, increased capture rate,
        unlimited ad audience contacts synced, and dedicated customer support
        and onboarding.
      </div>
      <BookDemoButton
        button="Talk to Us"
        className={styles.footerButton}
        utm={BILLING_PAGE_UTM('talktous')}
        onEventScheduled={onRequestEnteriprisePlanScheduled}
        show
      />
    </div>
  );
};

export const ManageSubsctiptionPanel = () => {
  const history = useHistory();
  const { accountName = '' } =
    (history.location.state as ManageSubsctiptionProps) || {};

  const handleBack = () => {
    history.push(SettingsRoutes.billing.getLink());
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={styles.navigation}>
          <div className={styles.back} onClick={handleBack}>
            <ArrowLeftOutlined />
            <div>Back to Billing</div>
          </div>
        </div>
        <div className={styles.pageName}>{accountName}</div>
        <div>Manage your plan</div>
      </div>
      <BillingPlans hideFreePlan onBillingSuccess={handleBack} />
      <BillingModalFooter />
    </div>
  );
};
